module.exports = __webpack_public_path__ + "static/media/arrow-black.5f85e537.svg";